import React from 'react'
import { Col, Row, Card } from 'react-bootstrap';
import Image from 'react-bootstrap/Image';
import img from '../img/SELS2.jpg'
import img1 from '../img/New Pics/sea-export.jpg'
import img2 from '../img/New Pics/FFP.jpg'
import './AirExportLogisticsSoftware.css';
import './About.css';
import Sidebar from './Sidebar';

function SeaExportLogisticsSoftware() {
  return (
    <>
    <Image className="fade-in responsive-img" src={img} height={500} width="100%" fluid />
    <div className="container my-4 fs-6">
      <Row>
        <Col xs={12} sm={9}>
          <h1 className='mt-5 pt-4 text-danger'>Sea Export Logistics Software</h1>
          {/* <Image className='my-2 fade-in' src={img} height={500} fluid /> */}
          <p className='text-justify'>The Catus Ocean/Sea Export Logistics Software Module is a comprehensive solution designed to efficiently manage container shipments throughout their entire life-cycle, from initiation to final delivery. This advanced module empowers you to oversee every stage of the shipment process, starting from the point of origin, through transportation via cargo ships, and all the way to the destination port. It provides a robust framework to handle critical tasks such as booking, documentation, tracking, customs clearance, and delivery coordination with unparalleled precision.</p>
          <p className='text-justify'>Equipped with the most powerful and flexible tools, the Catus Ocean Sea Export Logistics Software is engineered to maximize your operational productivity while significantly reducing costs with minimal manual effort. The software streamlines complex workflows, automates repetitive tasks, and offers real-time visibility into shipment statuses, enabling you to make informed decisions swiftly. Its user-friendly interface and customizable features cater to the unique needs of your business, ensuring scalability and adaptability as your operations grow.</p>
          <p className='text-justify'>The advanced technology embedded in this software guarantees end-to-end functionality, covering every aspect of the sea export logistics process. This includes managing container loading and unloading, optimizing shipping routes, ensuring compliance with international trade regulations, and providing detailed reporting for performance analysis. By integrating cutting-edge analytics and automated alerts, the software minimizes delays, enhances resource allocation, and improves overall supply chain efficiency, making it an indispensable tool for modern logistics management.</p>
          {/* //Want to remove// */}
          <div className='text-center'><Image className="my-5 fade-in animated-card" src={img2} height={400} fluid /></div>
          {/* //Want to remove// */}

        </Col>
        <Col xs={12} sm={3}>
          <Sidebar />
        </Col>
        <Col>
          <Card className='my-2 animated-card' border="primary">
            <Card.Body className='fs-6'><strong>Key Features</strong></Card.Body>
            <hr />
            <Card.Body>
              <Row>
                <Col md={4}><ul>
                  <li className='fs-6'>Create Quotation for existing and new customers </li>
                  <li className='fs-6'>Job Folder</li>
                  <li className='fs-6'>Master Bill of Lading Entry/ Printing</li>
                  <li className='fs-6'>Shipper Invoice /Shipping Bill Details</li>
                  <li className='fs-6'>House Consolidation and Printing</li>
                  <li className='fs-6'>Container Register</li>
                  <li className='fs-6'>Vessel Register</li>
                  <li className='fs-6'>Brokerages & Refunds</li>
                  <li className='fs-6'>Events and Transportation Details</li>
                  <li className='fs-6'>Acknowledgement Note</li>
                  <li className='fs-6'>Document Despatch Details</li>

                </ul></Col>
                <Col md={4} className="d-flex justify-content-center">
                  <img
                    src={img1}
                    alt="Features Illustration"
                    style={{ maxWidth: '100%', height: 'auto', borderRadius: '8px' }}
                  /></Col>
                <Col md={4}>
                  <ul>
                    <li className='fs-6'>Shipment Status Report</li>
                    <li className='fs-6'>Shipped On Board Certificate</li>
                    <li className='fs-6'>Shipment Landing Certificate</li>
                    <li className='fs-6'>Importer security Filing</li>
                    <li className='fs-6'>Job Cover</li>
                    <li className='fs-6'>Sales Report (For a Period)</li>
                    <li className='fs-6'>Job Costing (On a Single Click)</li>
                    <li className='fs-6'>Job Register Date wise/Party wise</li>
                    <li className='fs-6'>Master Airwaybill Register</li>
                    <li className='fs-6'>House Airwaybill Register</li>
                    <li className='fs-6'>And Many More…</li>
                  </ul>
                </Col>
              </Row>
            </Card.Body>
          </Card>
          <ul className='my-4'>
            <li className='fs-6'><strong>Comprehensive Shipment Management</strong>: Oversees the entire process including booking, documentation, tracking, customs clearance, and delivery.</li>
            {/* <p className='mx-4 my-0'></p> */}
            <li className='fs-6'><strong>Powerful Tools</strong>: Offers flexible and robust tools to enhance productivity and reduce costs with minimal effort.</li>
            <li className='fs-6'><strong>End-to-End Functionality</strong>: Provides a seamless workflow from container loading to final delivery, ensuring all logistics aspects are covered.</li>
            <li className='fs-6'><strong>Real-Time Tracking</strong>: Delivers live updates on shipment statuses for proactive decision-making.</li>
            <li className='fs-6'><strong>Customizable Interface</strong>: Adapts to specific business needs, ensuring scalability and efficiency.</li>
            <li className='fs-6'><strong>Automated Processes</strong>: Streamlines repetitive tasks and optimizes shipping routes.</li>
            <li className='fs-6'><strong>Regulatory Compliance</strong>: Ensures adherence to international trade regulations.</li>
            <li className='fs-6'><strong>Detailed Reporting</strong>: Generates in-depth reports for performance analysis and resource optimization.</li>
          </ul>
          <h4>Benefits</h4>
          <p className='text-justify'>Maximizes operational efficiency with advanced automation.</p>
          <p className='text-justify'>Reduces operational costs through optimized resource allocation.</p>
          <p className='text-justify'>Enhances supply chain visibility with real-time analytics.</p>
          <p className='text-justify'>Minimizes delays with automated alerts and route optimization.</p>
        </Col>
      </Row>
    </div>
    </>
  )
}

export default SeaExportLogisticsSoftware